// extracted by mini-css-extract-plugin
var _1 = "AdminAppearanceView-module__badgeContainer--bwQBV";
var _2 = "AdminAppearanceView-module__field--t92MS";
var _3 = "AdminAppearanceView-module__fieldContainer--kCA0v";
export { _1 as "badgeContainer", _2 as "field", _3 as "fieldContainer" }
